module.exports = __webpack_public_path__ + "img/en_ambassador.8b158d82.gif";